export default "__VITE_ASSET__CLDNcMTg__"